import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import ReviewStats from 'marketplace-ui-reviews/records/ReviewStats';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { GET_REVIEWS } from 'marketplace-ui-reviews/queries/getReviewsQuery';
import Review from 'marketplace-ui-reviews/records/Review';
import { GET_REVIEW_STATS } from 'marketplace-ui-reviews/queries/getReviewStatsQuery';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
const useReviewsRequest = (appContext, reviewFilters, offeringId) => {
  const {
    data: reviewsData,
    loading: reviewsLoading,
    error: reviewsError
  } = useQuery(GET_REVIEWS, {
    variables: {
      appContext: appContext === 'admin-preview' ? 'public' : appContext,
      reviewType: ReviewTypes.APP,
      queries: reviewFilters.toSearchQuery()
    }
  });
  const {
    data: reviewStatsData,
    loading: reviewStatsLoading,
    error: reviewStatsError
  } = useQuery(GET_REVIEW_STATS, {
    variables: {
      appContext: appContext === 'admin-preview' ? 'public' : appContext,
      offeringId,
      reviewType: ReviewTypes.APP
    }
  });
  const {
    reviewStats,
    reviewStatsFetchStatus
  } = useMemo(() => {
    return {
      reviewStats: new ReviewStats(reviewStatsData && reviewStatsData.reviewStatsResponse || null).set('reviewType', ReviewTypes.APP),
      reviewStatsFetchStatus: getDataFetchingClientRequestState(reviewStatsError, reviewStatsLoading)
    };
  }, [reviewStatsData, reviewStatsError, reviewStatsLoading]);
  const reviewsCount = reviewStats.get('count') || 0; // All reviews
  const {
    reviews,
    reviewsTotal,
    // Based on current filters
    reviewsFetchStatus
  } = useMemo(() => ({
    reviews: Review.fromArray(reviewsData && reviewsData.reviewsResponse.reviews || [], ReviewTypes.APP),
    reviewsTotal: reviewsData && reviewsData.reviewsResponse.total || 0,
    reviewsFetchStatus: getDataFetchingClientRequestState(reviewsError, reviewsLoading)
  }), [reviewsData, reviewsError, reviewsLoading]);
  return {
    reviews,
    reviewStats,
    reviewsFetchStatus,
    reviewStatsFetchStatus,
    reviewsTotal,
    reviewsCount
  };
};
export default useReviewsRequest;